import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { getGitSyncState, GitSyncState } from '../services/apiService';

const POLL_INTERVAL_MS = 60_000;

function formatRelative(iso: string | null): string {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  const diff = Date.now() - then;
  if (diff < 60_000) return 'há menos de 1 min';
  const mins = Math.floor(diff / 60_000);
  if (mins < 60) return `há ${mins} min`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `há ${hours}h`;
  const days = Math.floor(hours / 24);
  return `há ${days}d`;
}

export const GitSyncBanner: React.FC = () => {
  const [state, setState] = useState<GitSyncState | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetchState = async () => {
      try {
        const s = await getGitSyncState();
        if (!cancelled) setState(s);
      } catch {
        // silent — endpoint may not exist on older backends
      }
    };

    fetchState();
    const interval = setInterval(fetchState, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  if (!state || state.last_push_ok) return null;

  return (
    <div className="bg-red-50 border-b border-red-200 px-4 py-2 flex items-start gap-2 text-sm">
      <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-red-900">
          Sincronização com GitHub falhou {formatRelative(state.last_failure_at)}
          {state.consecutive_failures > 1 && (
            <span className="ml-1 font-normal">
              ({state.consecutive_failures} falhas consecutivas)
            </span>
          )}
        </div>
        {state.last_failure_reason && (
          <div className="text-red-800 text-xs mt-0.5 font-mono break-all">
            {state.last_failure_reason}
          </div>
        )}
        <div className="text-red-700 text-xs mt-1">
          Dados estão salvos localmente, mas não foram enviados ao repositório
          remoto. Verifique o GITHUB_TOKEN e a conectividade do container.
        </div>
      </div>
    </div>
  );
};
